import React from "react";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import {
  FormControl,
  Input,
  InputLabel,
  makeStyles,
  MenuItem,
  Select
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import ReactTable from "react-table";
import { bookingApi } from "functions/apis";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { formatTripDate } from "functions/Helper";
import { formatDateTime } from "functions/Helper";
import AddIcon from "@material-ui/icons/Add";
import { token } from "functions/Helper";
import AgentDialog from "components/AgentDialog/AgentDialog";

const useStyles = makeStyles(styles);

const sortOptionsList = [
  "NO_ASC",
  "NO_DESC",
  "TRANSACTION TIME ASC",
  "TRANSACTION TIME DESC"
];

export default function AgentBookingPendingList() {
  const classes = useStyles();

  const fetchDataSignal = new AbortController();

  const [filter, setFilter] = React.useState({
    searchString: "",
    status: 0,
    sort: 4
  });
  const [pagination, setPagination] = React.useState({
    pageSize: 10,
    pageIndex: 1
  });
  const [data, setData] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [pages, setPages] = React.useState(0);
  const [showModal, setShowModal] = React.useState(false);
  const [agent, setAgent] = React.useState(null);

  React.useEffect(() => {
    fetchAllData();
  }, [filter, pagination]);

  const fetchAllData = () => {
    setLoading(true);
    bookingApi
      .get("AgentBookings", {
        signal: fetchDataSignal.signal,
        params: {
          filter,
          pagination
        }
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token.is_admin === "True" ||
                    token["booking.agent_bookings.read"] === "allowed") && (
                    <Link to={"/admin/AgentBooking/Detail/" + record.id}>
                      <Button
                        color="info"
                        className="like"
                        type="button"
                        value="VIEW"
                      >
                        <VisibilityIcon /> VIEW
                      </Button>
                    </Link>
                  )}
                  {(token.is_admin === "True" ||
                    token["booking.agent_booking_notes.write"] ===
                      "allowed") && (
                    <Link to={"/admin/AgentBooking/AddNotes/" + record.id}>
                      <Button
                        color="info"
                        className="like"
                        type="button"
                        value="VIEW"
                      >
                        <AddIcon />
                        ADD NOTES
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
      })
      .catch(error => console.log(error))
      .finally(() => setLoading(false));
  };

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target?.value === "" ? null : e.target?.value
    });

  const handleSortOptionsChanged = e =>
    setFilter({
      ...filter,
      sort: e.target.value
    });

  const handleAgentIDChanged = e => {
    setShowModal(false);
    setAgent(e);
    setFilter(prev => ({
      ...prev,
      agentID: e.id === "" ? null : e.id
    }));
  };
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              AGENT BOOKING PENDING LIST
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel htmlFor="selSort" className={classes.selectLabel}>
                    SORT BY
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={filter.sort ?? ""}
                    onChange={handleSortOptionsChanged}
                  >
                    {sortOptionsList.map((record, idx) => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={idx}
                          key={idx}
                        >
                          <p>{record}</p>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12}>
                <FormControl
                  fullWidth
                  className={classes.selectFormControl}
                  onClick={() => (!showModal ? setShowModal(true) : null)}
                  style={{ cursor: "pointer" }}
                >
                  <InputLabel
                    htmlFor="selAgent"
                    className={classes.selectLabel}
                    style={{ pointerEvents: "none" }}
                  >
                    Agent
                  </InputLabel>

                  <Input
                    className={classes.select}
                    value={agent ? agent.name : ""}
                    disabled
                    style={{ pointerEvents: "none" }}
                  />

                  <AgentDialog
                    openModal={showModal}
                    setOpenModal={val => setShowModal(val)}
                    onSelect={handleAgentIDChanged}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value: filter.searchString
                  }}
                />
              </GridItem>
            </GridContainer>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  Header: "No",
                  accessor: "no"
                },
                {
                  id: "transactionTime",
                  Header: "Transaction Time",
                  accessor: d =>
                    formatDateTime(new Date(d.transactionTime + "Z"))
                },
                {
                  Header: "Confirmation Code",
                  accessor: "confirmationCode"
                },
                {
                  id: "user",
                  Header: "Agent",
                  accessor: d => d.agent.name.toString()
                },
                {
                  id: "isRoundTrip",
                  Header: "Is Round Trip",
                  accessor: d => (d.isRoundTrip ? "Yes" : "No")
                },
                {
                  id: "departure",
                  Header: "Departure",
                  accessor: d => (
                    <>
                      <p>{d.latestDepartureCoreApiTrip.route.code}</p>
                      <p>
                        {formatTripDate(
                          new Date(d.latestDepartureCoreApiTrip.date)
                        )}
                      </p>
                      <p>{d.latestDepartureCoreApiTrip.time}</p>
                    </>
                  )
                },
                {
                  id: "return",
                  Header: "Return",
                  accessor: d =>
                    d.isRoundTrip ? (
                      d.isReturnTripOpen ? (
                        <p>OPEN RETURN TRIP</p>
                      ) : (
                        <>
                          <p>{d.latestReturnCoreApiTrip.route.code}</p>
                          <p>
                            {formatTripDate(
                              new Date(d.latestReturnCoreApiTrip.date)
                            )}
                          </p>
                          <p>{d.latestReturnCoreApiTrip.time}</p>
                        </>
                      )
                    ) : (
                      <p>NO RETURN</p>
                    )
                },
                {
                  id: "currency",
                  Header: "Currency",
                  accessor: d =>
                    d.agent ? d.agent.billingCurrency.code.toString() : "-"
                },
                {
                  id: "outstandingAmount",
                  Header: "Outstanding Amount",
                  accessor: d => d.outstandingAmount.toLocaleString()
                },
                {
                  id: "voucherAmount",
                  Header: "Voucher Amount",
                  accessor: d => d.voucherAmount.toLocaleString()
                },
                {
                  id: "notes",
                  Header: "Notes",
                  accessor: d => d.notes
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false,
                  width: 200
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
